"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var classnames_1 = __importDefault(require("classnames"));
var Option = function (_a) {
    var className = _a.className, collapseControl = _a.collapseControl, collapsed = _a.collapsed, content = _a.content, disabled = _a.disabled, focus = _a.focus, label = _a.label, level = _a.level, loading = _a.loading, onChange = _a.onChange, onExpand = _a.onExpand, onKeyDown = _a.onKeyDown, options = _a.options, readOnly = _a.readOnly, secondaryAction = _a.secondaryAction, selected = _a.selected, selfObject = _a.selfObject, text = _a.text, value = _a.value, props = __rest(_a, ["className", "collapseControl", "collapsed", "content", "disabled", "focus", "label", "level", "loading", "onChange", "onExpand", "onKeyDown", "options", "readOnly", "secondaryAction", "selected", "selfObject", "text", "value"]);
    var OptionClasses = classnames_1.default('OptionList__option', className, {
        'OptionList__option--selected': selected,
        'OptionList__option--disabled': disabled,
        'OptionList__option--read-only': readOnly || disabled,
        'OptionList__option--custom': content && typeof content !== 'string',
        'OptionList__option--text': !(content && typeof content !== 'string'),
    });
    var getCollapseButton = function () {
        if (!collapseControl)
            return;
        var arrow = collapsed
            ? 'keyboard_arrow_down'
            : 'keyboard_arrow_right';
        return (react_1.default.createElement(__1.Button, { iconName: arrow, xsmall: true, fill: "subtle", onClick: handleOnClick, className: "OptionList__collapse" }));
    };
    var getLabel = function () {
        if (label)
            return label;
        if (content !== undefined && content !== null)
            return content;
        if (text !== undefined && text !== null)
            return text;
        return String(value);
    };
    var getLoading = function () {
        if (!loading)
            return;
        return react_1.default.createElement(__1.Spinner, { size: "tiny", className: "OptionList__spinner" });
    };
    var getSecondaryAction = function () {
        if (secondaryAction === undefined)
            return;
        return (react_1.default.createElement("div", { className: "OptionList__option--secondary-action" }, secondaryAction));
    };
    var handleOnClick = function () {
        return onExpand(value);
    };
    var handleOnChange = function () {
        if (readOnly || onChange === undefined)
            return;
        return onChange(value, !selected, options, selfObject);
    };
    var handleOnKeyDown = function (e) {
        if (onKeyDown === undefined)
            return;
        return onKeyDown(e, selfObject);
    };
    return (react_1.default.createElement("div", __assign({ className: OptionClasses, "aria-level": level }, props),
        getLoading() || getCollapseButton(),
        react_1.default.createElement(__1.Checkbox, { checked: selected, disabled: disabled, focus: focus, label: getLabel(), onChange: handleOnChange, onKeyDown: handleOnKeyDown, value: value }),
        getSecondaryAction()));
};
exports.Option = Option;
//# sourceMappingURL=Option.js.map